<!--  -->
<template>
  <div>
    <!-- <el-input v-model="keyword" style="width:200px;margin-bottom:10px" placeholder="请输入内容" />
    <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="sraw">搜索</el-button>
    <el-button type="primary" @click="awered">重置</el-button> -->
    <div class="bookavaw">
      <el-table
        ref="table"
        :key="refreshKey"
        v-loading="loading"
        :data="publicAdvertListr"
        border
        style="width: 100%"
      >
        <!-- <el-table-column
        align="center"
        label="选项"
        width="100"
      >
        <template slot-scope="scope">
          <input
            v-model="scope.row.checkboxFlag"
            type="checkbox"
            @click="handleChangeSelectone(scope.$index, scope.row)"
          >
          {{ scope.row.$index }}
        </template>
      </el-table-column> -->
        <el-table-column
          align="center"
          prop="chapter_id"
          label="章节id"
          width="180"
        />
        <el-table-column
          align="center"
          prop="chapter_name"
          label="章节名称"
          width="300"
        />

        <el-table-column
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="chooserr(scope.row,scope.$index)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    /> -->
  </div>
</template>

<script>
import { createtemplate } from '@/api/sourceMaterial.js'
// import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    // PaginationRight
  },
  data() {
    return {
      input: '',
      page: 1,
      pageSize: 10,
      keyword: null,
      refreshKey: 0,
      loading: false,
      publicAdvertListr: [],
      newtotalr: null,
      kefuid: '',
      query: null,
      querybookid: null,
      indexids: '', // 下一章节id
      indename: ''// 下一章节名称
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    // 获取客服消息
    menuList() {
      this.loading = true
      createtemplate({
        // page: this.page,
        // page_size: this.pageSize,
        novel_id: this.querybookid,
        platform_id: this.query
      }).then(res => {
        console.log('res', res)
        this.publicAdvertListr = res.data.chapter
        this.loading = false
        // this.publicAdvertListr.forEach(item => {
        //   // item.checkboxFlag = false
        //   this.$set(item, 'checkboxFlag', false)
        //   if (item.customerMessageNo === this.kefuid) {
        //     item.checkboxFlag = true
        //   }
        // })
        // this.newtotalr = res.data.data.total
      })
    },
    sraw() {
      this.page = 1
      this.pageSize = 10
      this.menuList()
    },
    awered() {
      this.page = 1
      this.pageSize = 10
      this.keyword = null
      this.menuList()
    },
    send(parid, bookid) {
      this.query = parid
      this.querybookid = bookid
      // if (val === '') {
      //   console.log('kong')
      // } else {
      //   this.kefuid = val
      //   console.log('bukong')
      // }
      this.menuList()
    },
    // 分页
    // fetchPageSizer(e) {
    //   this.pageSize = e
    //   this.menuList()
    // },
    // fetchCurrentPager(e) {
    //   this.page = e
    //   this.menuList()
    // },
    handleChangeSelectone(index) {
      console.log(this.publicAdvertListr[index])
      if (!this.publicAdvertListr[index].checkboxFlag) {
        console.log('item', this.publicAdvertListr[index])
        this.$emit('callback', this.publicAdvertListr[index].customerMessageNo)
      } else {
        // this.selectData = null
      }
      this.publicAdvertListr.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvertListr[index].checkboxFlag = true
    },
    chooserr(item, index) {
      console.log('index', this.publicAdvertListr.length, index + 1)
      this.indexids = ''
      this.indename = ''
      // eslint-disable-next-line eqeqeq
      if (this.publicAdvertListr.length == index + 1) {
        this.indexids = this.publicAdvertListr[index].chapter_id
        this.indename = this.publicAdvertListr[index].chapter_name
      } else {
        this.indexids = this.publicAdvertListr[index + 1].chapter_id
        this.indename = this.publicAdvertListr[index + 1].chapter_name
      }
      this.$emit('chaptercallback', item, this.indexids, this.indename)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.bookavaw{
  height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
